import { useEffect } from "react";

const setMeta = (attr, key, content) => {
    let el = document.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
};

export default function useSEO({ title, description, ogImage }) {
    useEffect(() => {
        if (title) document.title = title;
        if (description) {
            setMeta("name", "description", description);
            setMeta("property", "og:description", description);
        }
        if (ogImage) setMeta("property", "og:image", ogImage);
    }, [title, description, ogImage]);
}
